module.exports = __webpack_public_path__ + "9c339db0986dea8c83dca4c18dce3e53.svg";